/**
 * Update & Maintenance — OTA update mechanisms, physical update
 * methods, remote access capabilities. Pulls from
 * `formatted.update_and_maintenance`. Always renders.
 */
import React from 'react';
import { SectionCard, SubSection, ObjectListField, type SectionProps } from './parts';

const PATH = ['update_and_maintenance'];

const yesNo = (v) => (v === true ? 'true' : v === false ? 'false' : '');
const joinList = (v) => (Array.isArray(v) ? v.join(', ') : v);

export default function UpdateMaintenance({ data, isEditing, onChange }: SectionProps) {
  const um = data ?? {};
  const ota = um.ota_updates?.mechanisms ?? [];
  const physical = um.physical_updates?.methods ?? [];
  const remote = um.remote_access?.capabilities ?? [];

  const otaColumns = [
    { key: 'update_protocol', label: 'Protocol' },
    { key: 'authentication_method', label: 'Auth Method' },
    { key: 'update_server', label: 'Server' },
    { key: 'update_frequency', label: 'Frequency' },
    { key: 'differential_updates', label: 'Differential', render: yesNo },
    { key: 'rollback_capability', label: 'Rollback', render: yesNo },
    { key: 'fail_safe_mechanism', label: 'Fail-safe' },
    { key: 'update_verification', label: 'Verification', render: joinList },
  ];
  const physColumns = [
    { key: 'method_type', label: 'Method' },
    { key: 'authentication_required', label: 'Auth Required', render: yesNo },
    { key: 'access_level', label: 'Access Level' },
    { key: 'security_controls', label: 'Security Controls', render: joinList },
  ];
  const remoteColumns = [
    { key: 'access_method', label: 'Method' },
    { key: 'purpose', label: 'Purpose' },
    { key: 'authentication_requirements', label: 'Auth Required', render: joinList },
    { key: 'authorization_levels', label: 'Authorization', render: joinList },
    { key: 'accessible_functions', label: 'Functions', render: joinList },
    { key: 'security_controls', label: 'Security Controls', render: joinList },
    { key: 'logging_monitoring', label: 'Logging', render: yesNo },
  ];

  return (
    <SectionCard title="Update & Maintenance" id="update_and_maintenance">
      <SubSection title="OTA updates" count={ota.length}>
        <ObjectListField columns={otaColumns} rows={ota} isEditing={isEditing} onChange={onChange} path={[...PATH, 'ota_updates', 'mechanisms']} />
      </SubSection>

      <SubSection title="Physical updates" count={physical.length}>
        <ObjectListField columns={physColumns} rows={physical} isEditing={isEditing} onChange={onChange} path={[...PATH, 'physical_updates', 'methods']} />
      </SubSection>

      <SubSection title="Remote access" count={remote.length}>
        <ObjectListField columns={remoteColumns} rows={remote} isEditing={isEditing} onChange={onChange} path={[...PATH, 'remote_access', 'capabilities']} />
      </SubSection>
    </SectionCard>
  );
}
